<template>
  <div class="header-box" :class="{ 'download-header': isdownload }">
    <main-header-pc
      :class="[
        'pc-show',
        { 'transparent-theme': specialHeader },
      ]"
    ></main-header-pc>
    <!-- <transition name="slide-fade">
      <main-header-pc :class="['pc-show transition-header', 'gradient-theme']" v-show="headerFixed"></main-header-pc>
    </transition> -->

    <main-header-phone
      :class="[
        'phone-show',
        { 'transparent-theme': specialHeader },
      ]"
    ></main-header-phone>
    <!-- <transition name="slide-fade">
      <main-header-phone
        :class="['phone-show transition-header', 'gradient-theme']"
        v-show="headerFixed"
      ></main-header-phone>
    </transition> -->
  </div>
</template>

<script>
import MainHeaderPc from "./MainHeaderPc.vue";
import MainHeaderPhone from "./MainHeaderPhone.vue";
import { SET_USER_INFO } from "../../../store/mutation-types";
import $ from "jquery";

export default {
  name: "main-header",
  components: { MainHeaderPc, MainHeaderPhone },
  data() {
    return {
      headerFixed: false,
    };
  },
  computed: {
    specialHeader() {
      return this.$store.state.header.specialHeader;
    },
    bidstNum() {
      return this.$store.state.header.bigstCount;
    },
    isdownload() {
      return this.$store.state.header.isdownload;
    },
  },
  watch: {
    $route() {
      this.setLoginMsg();
    },
  },
  created() {
    window.addEventListener("scroll", this.showHeader);
  },
  destroyed() {
    window.removeEventListener("scroll", this.showHeader);
  },
  mounted() {
    this.setLoginMsg();
  },
  methods: {
    showHeader: function () {
      if ($(window).scrollTop() >= 300) {
        this.headerFixed = true;
        this.$store.commit("setPhoneHeaderLogoFlag", true);
        this.$store.commit("setIsHeader", true);
      } else {
        this.headerFixed = false;
        this.$store.commit("setPhoneHeaderLogoFlag", false);
        this.$store.commit("setIsHeader", false);
      }
    },
    setLoginMsg() {
      const userInfo = window.localStorage.getItem("userInfo");
      const token = window.localStorage.getItem("token");
      if (userInfo) {
        this.$store.commit(SET_USER_INFO, JSON.parse(userInfo));
      }
      if (!token && !userInfo) {
        this.$store.dispatch("clearUserInfo");
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.header-box {
  width: 100%;
  position: relative;
  z-index: 10;
}
.header-box.download-header {
  // position: relative;
  // top: 80px;
  // z-index: 10;
}
.transition-header {
  position: fixed;
  top: 0;
  z-index: 3;
  width: 100%;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1);
}

.slide-fade-enter-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-active {
  transform: translateY(-10px);
  opacity: 0;
}

@media screen and (max-width: 991px) {
  .pc-show {
    display: none;
  }
}

@media screen and (min-width: 992px) {
  .phone-show {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?ef1e5fe4